import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/content";
import { scrollToId } from "@/lib/scroll";

export const Services = () => {
  const [hovered, setHovered] = useState(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });

  const scrollToContact = () => scrollToId("contact");

  return (
    <section
      id="services"
      className="relative bg-espresso py-24 md:py-32"
      onMouseMove={(e) => setPos({ x: e.clientX, y: e.clientY })}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-6">
          <div>
            <p className="text-xs uppercase tracking-[0.28em] text-blush mb-5">(What we offer)</p>
            <h2 className="font-serif font-light text-cream text-4xl md:text-6xl tracking-tight max-w-xl leading-[1.02]">
              Services, tailored to your home
            </h2>
          </div>
          <p className="max-w-xs text-cream/60 font-light">Hover a service to preview. Every package is customised after a walkthrough.</p>
        </div>

        <div className="border-t border-cream/15">
          {SERVICES.map((s, i) => (
            <motion.button
              key={s.title}
              data-testid={`service-row-${i}`}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              onClick={scrollToContact}
              className="group w-full text-left border-b border-cream/15 py-6 md:py-8 grid grid-cols-[auto_1fr_auto] items-start md:items-center gap-6 md:gap-10"
            >
              <span className="font-serif text-xl md:text-2xl text-blush/70 w-10">{String(i + 1).padStart(2, "0")}</span>
              <div className="min-w-0">
                <h3 className="font-serif font-light text-3xl md:text-5xl text-cream group-hover:text-blush group-hover:translate-x-3 transition-all duration-500">
                  {s.title}
                  {s.tag && <span className="align-middle ml-4 text-[10px] uppercase tracking-[0.2em] bg-cream text-espresso px-3 py-1 rounded-full">{s.tag}</span>}
                </h3>
                <p className="mt-2 text-cream/60 font-light max-w-lg text-sm md:text-base">{s.desc}</p>
              </div>
              <ArrowUpRight className="text-cream/50 group-hover:text-blush group-hover:rotate-45 transition-all duration-500 shrink-0" size={30} />
            </motion.button>
          ))}
        </div>
      </div>

      {/* Floating hover image */}
      <AnimatePresence>
        {hovered !== null && (
          <motion.div
            initial={{ opacity: 0, scale: 0.85 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.85 }}
            transition={{ duration: 0.3 }}
            style={{ left: pos.x, top: pos.y }}
            className="pointer-events-none fixed z-40 hidden lg:block -translate-x-1/2 -translate-y-1/2"
          >
            <div className="w-72 h-96 overflow-hidden shadow-2xl">
              <img src={SERVICES[hovered].img} alt={SERVICES[hovered].title} className="w-full h-full object-cover" />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};
